// extracted by mini-css-extract-plugin
module.exports = {"markdown":"index_markdown__GJ4BB","citationAnchorLink":"index_citationAnchorLink__mhVdv","citationNoteAnchorLink":"index_citationNoteAnchorLink__WhZek"};